import React from 'react';

const RightIcon = props => (
  <svg width={16} height={16} {...props}>
    <path
      d="M10.806 8.002l-6.66-6.213a.44.44 0 0 1 0-.654.521.521 0 0 1 .7 0l7.009 6.538a.44.44 0 0 1 0 .654l-7.009 6.538a.521.521 0 0 1-.7 0 .44.44 0 0 1 0-.654l6.66-6.209z"
      fill={props.color}
      fillRule="nonzero"
    />
  </svg>
);

export default RightIcon;


// WEBPACK FOOTER //
// ./src/components/Field_Components/RichEditor/Icon/RightIcon.js